'use strict';
import $service from '@/common/service/api-service';
import service from '@/common/service/index.js';
import $paramsService from '@/common/service/params-service';
import $config from '@/config';

function apiData(context, params, mutaName) {
  context.commit('setSoLoaded', false);
  context.commit(mutaName, {});
  $service.post('/c/so/search', params)
    .then(res => {
      if (res && res.code === 1) {
        let dig = _.get(res, 'data.dig');
        if (dig) {
          context.commit('setSoParams', _.assign(context.state.soParams, {
            dig: dig
          }));
        }

        if (_.some(_.pick(res.data, ['records', 'profiles', 'memberSocial', 'socials', 'websites', 'contact', 'email']),
            (value) => !_.isEmpty(value))) {
          res.data.time = res.time;
          context.commit(mutaName, res.data);
        } else {
          context.commit(mutaName, {
            time: res.time,
            error: 90001
          });
        }

        //加载历史
        let options = {
          params: {
            type: context.state.soSearchType,
            current: 1,
            pageSize: 5
          },
          mutaName: 'setHistory'
        };
        context.dispatch('soHistoryData', options);
      } else {
        context.commit(mutaName, {
          time: res.time,
          error: res.code
        });
      }
      context.commit('setSoLoaded', true);
    });
}

export default {
  soSearchData(context, options) {
    let params = {};
    if (options.research) {
      params.research = true;
    }

    const isSearchEmailInCompany = context.state.searchEmailInCompany && options.path == "/so/email";

    params.searchType = isSearchEmailInCompany ? 2 : context.state.soSearchType;

    if (_.includes(options.path, 'single')) {
      apiData(context, _.assign(params, _.assign(_.pick(context.state.soParams, 'keyword'))), 'setEmailList');
    } else if (_.includes(options.path, 'company')) {
      const sentParams = {
        keyword: context.state.soParams.keyword,
        force: false
      };
      (context.state.submitCid && context.state.soParams.cid && context.state.soParams.cid !== '') ? (sentParams['cid'] =
        context.state.soParams.cid) : '';
      apiData(context, _.assign(params, sentParams), 'setCompanyInfo');
    } else if (_.includes(options.path, 'email')) {
      if (context.state.soParams.digKeyword) {
        if ($paramsService.isDomain(context.state.soParams.digKeyword)) {
          apiData(context, _.assign(params, {
            keyword: context.state.soParams.digKeyword,
            dig: context.state.soParams.dig
          }), 'setEmailList');
        } else {
          apiData(context, _.assign(params, {
            keyword: context.state.soParams.digKeyword,
            dig: context.state.soParams.dig,
            force: true
          }), 'setEmailList');
        }
      }
    }
  },
  soHistoryData(context, options) {
    $service.post('/c/so/search-history/paging', options.params)
      .then(res => {
        if (res && res.code === 1) {
          context.commit(options.mutaName, res.data);
        } else {
          context.commit(options.mutaName, {
            error: res.code
          });
        }
      });
  },
  addInfoToCrm(context, args = {}) {
    return service.requestPromise('/crm/customer/saveCustomerInfo', {
      method: 'post',
      params: args.params
    })
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/so/action.js